/** The API tokens page's tabs, as URL segments (context STORY-0271): `/tokens/$tab`. */
export const TOKEN_TABS = ['server', 'applications'] as const;
export type TokenTab = (typeof TOKEN_TABS)[number];
export const isTokenTab = (s: string): s is TokenTab => (TOKEN_TABS as readonly string[]).includes(s);
